module.exports = __webpack_public_path__ + "img/E-WEB-Goal-04.d4d6a451.svg";